var e4 = e4 || {},
    dcc = dcc || {};
( function () {
    'use strict';
    dcc.isStaging = function () {
        return location.href.indexOf( 'staging' ) > -1;
    };
    dcc.currencyChanger = {
        init: function () {
            dcc.currencyChanger.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-dcc-change-currency' ).on( 'click', function ( event ) {
                event.preventDefault();
                var strDebitorCurrencyCode = event.currentTarget.dataset.value;
                if ( strDebitorCurrencyCode !== undefined ) {
                    dcc.currencyChanger.findCurrency( strDebitorCurrencyCode.toLowerCase() );
                }
            } );
        },
        findCurrency: function ( strDebitorCurrencyCode ) {
            var currencyCode = '';
            if ( strDebitorCurrencyCode.indexOf( 'eur' ) > -1 ) {
                currencyCode = 'eur';
            }
            else if ( strDebitorCurrencyCode.indexOf( 'gbp' ) > -1 ) {
                currencyCode = 'gbp';
            }
            else if ( strDebitorCurrencyCode.indexOf( 'dkk' ) > -1 ) {
                currencyCode = 'dkk';
            }
            if ( currencyCode !== '' ) {
                dcc.currencyChanger.buildCurrencyChangeFormAndSubmit( currencyCode );
            }
        },
        buildCurrencyChangeFormAndSubmit: function ( currency ) {
            var form = document.createElement( 'form' ),
                currencyCodeInput = document.createElement( 'input' );
            form.method = 'POST';
            form.action = location.href;
            currencyCodeInput.type = 'hidden';
            currencyCodeInput.value = currency;
            currencyCodeInput.name = 'currencycode';
            form.appendChild( currencyCodeInput );
            document.body.appendChild( form );
            form.submit();
        }
    }, dcc.alert = function ( text, dialogue ) {
        var modal = jQuery( '#js-dcc-alert-modal' );
        modal.find( '.js-dcc-alert-modal-text' ).text( text );
        if ( dialogue === true ) {
            modal.find( '.js-dcc-alert-modal-dialogue-actions' ).removeClass( 'd-none' );
        }
        else {
            modal.find( '.js-dcc-alert-modal-dialogue-actions' ).addClass( 'd-none' );
        }
        modal.modal();
    };
    dcc.customercenter = {
        init: function () {
            dcc.customercenter.testForActiveTab();
            dcc.customercenter.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-tablist' ).on( 'shown.bs.tab', '.js-tablist-nav-link', function ( event ) {
                e4.util.hash.set( 'tab', event.target.hash.replace( '#', '' ) );
            } );
        },
        testForActiveTab: function () {
            var currentTab = e4.util.hash.get( 'tab' );
            if ( currentTab ) {
                jQuery( '.js-tablist-nav-link[href="#' + currentTab + '"]' ).tab( 'show' );
            }
            else {
                jQuery( '.js-tablist-nav-link' ).first().tab( 'show' );
            }
        },
        downloadOrderPDF: function ( domElm ) {
            var url = domElm.href;
            jQuery.get( url ).done( function ( data, textStatus, jqXHR ) {
                var respondsHeaders = jqXHR.getAllResponseHeaders().split( '\r\n' );
                for ( var i = 0; i < respondsHeaders.length; i++ ) {
                    var respondsHeader = respondsHeaders[ i ].split( ' ' );
                    if ( respondsHeader[ 0 ] === 'content-type:' ) {
                        if ( respondsHeader[ 1 ] === 'application/pdf' ) {
                            location.href = url;
                        }
                        else {
                            dcc.customercenter.downloadOrderPDFError();
                        }
                    }
                }
            } );
        },
        downloadOrderPDFError: function () {
            dcc.alert( 'Error downloading PDF', false );
        }
    }, dcc.productlist = {
        init: function () {
            dcc.productlist.presentation.init();
            dcc.productlist.searchUrlQuery();
            dcc.productlist.addToFavorites.init();
            dcc.productlist.plain.init();
        },
        addToFavorites: {
            init: function () {
                
            }
        },
        parseQueryString: function ( query ) {
            var vars = query.split( '&' ),
                query_string = {};
            for ( var i = 0; i < vars.length; i++ ) {
                var pair = vars[ i ].split( '=' ),
                    key = decodeURIComponent( pair[ 0 ] ),
                    value = decodeURIComponent( pair[ 1 ] );
                if ( typeof query_string[ key ] === 'undefined' ) {
                    query_string[ key ] = decodeURIComponent( value );
                }
                else if ( typeof query_string[ key ] === 'string' ) {
                    var arr = [
                        query_string[ key ],
                        decodeURIComponent( value )
                    ];
                    query_string[ key ] = arr;
                    // If third or later entry with this name
                }
                else {
                    query_string[ key ].push( decodeURIComponent( value ) );
                }
            }
            return query_string;
        },
        searchUrlQuery: function () {
            jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
                var jProductlist = jQuery( event.target ),
                    url = location.href,
                    locationSearch = window.location.search.substring( 1 ),
                    urlParams = dcc.productlist.parseQueryString( locationSearch );
                if ( urlParams.q && e4.productlist.data.hasLoadedQuery === false ) {
                    jProductlist.find( '.js-e-search-input' ).val( urlParams.q );
                    var cleanUrl = url.substring( 0, url.indexOf( '?' ) );
                    if ( Object.keys( urlParams ).length > 0 ) {
                        jQuery.each( urlParams, function ( key, value ) {
                            if ( key.indexOf( 'utm_' ) > -1 && cleanUrl.indexOf( key + '=' + value ) === -1 ) {
                                e4.productlist.history.utms[ key ] = value;
                                cleanUrl += ( cleanUrl.indexOf( '?' ) > -1 ? '&' : '?' ) + key + '=' + value;
                            }
                        } );
                    }
                    e4.productlist.data.hasLoadedQuery = true;
                    if ( jQuery( '#js-e-productlist-filters' ).length > 0 ) {
                        history.replaceState( null, null, cleanUrl );
                        e4.productlist.data.post();
                    }
                }
            } );
        },
        presentation: {
            typeSessionStorageKey: 'dcc.productlist.presentation.type.obj',
            viewPageID: function () {
                return jQuery( 'input[name="ViewPageID"]' ).val();
            },
            init: function () {
                var prensentationType = dcc.productlist.presentation.store.get();
                if ( prensentationType === 'list' ) {
                    dcc.productlist.presentation.setList( false );
                }
                else {
                    dcc.productlist.presentation.setGrid( false );
                }
                dcc.productlist.presentation.bindEvents();
            },
            bindEvents: function () {
                jQuery( '.js-productlist-presentation-btn-list' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    dcc.productlist.presentation.setList( true );
                } );
                jQuery( '.js-productlist-presentation-btn-grid' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    dcc.productlist.presentation.setGrid( true );
                } );
            },
            setGrid: function ( store ) {
                var jProductlist = jQuery( '.js-e-productlist' );
                jProductlist.addClass( 'dcc-productlist-presentation-grid' );
                jProductlist.removeClass( 'dcc-productlist-presentation-list' );
                if ( store === true ) {
                    dcc.productlist.presentation.store.set( 'grid' );
                }
            },
            setList: function ( store ) {
                var jProductlist = jQuery( '.js-e-productlist' );
                jProductlist.addClass( 'dcc-productlist-presentation-list' );
                jProductlist.removeClass( 'dcc-productlist-presentation-grid' );
                if ( store === true ) {
                    dcc.productlist.presentation.store.set( 'list' );
                }
            },
            store: {
                get: function () {
                    var viewPageID = dcc.productlist.presentation.viewPageID(),
                        presentationTypeObj = {};
                    if ( sessionStorage.getItem( dcc.productlist.presentation.typeSessionStorageKey ) !== null ) {
                        presentationTypeObj = JSON.parse( sessionStorage.getItem( dcc.productlist.presentation.typeSessionStorageKey ) );
                    }
                    if ( viewPageID === undefined || presentationTypeObj[ viewPageID ] === undefined ) {
                        presentationTypeObj[ viewPageID ] = jQuery( '.js-e-productslist-header' ).find( '.js-productlist-presentation-type' ).filter( '.default-presentation' ).data( 'presentation' );
                    }
                    return presentationTypeObj[ viewPageID ];
                },
                set: function ( presentation ) {
                    var presentationTypeObj = {},
                        viewPageID = dcc.productlist.presentation.viewPageID();
                    if ( viewPageID !== undefined ) {
                        if ( sessionStorage.getItem( dcc.productlist.presentation.typeSessionStorageKey ) !== null ) {
                            presentationTypeObj = JSON.parse( sessionStorage.getItem( dcc.productlist.presentation.typeSessionStorageKey ) );
                            presentationTypeObj[ viewPageID ] = presentation;
                        }
                        else {
                            presentationTypeObj = {};
                            presentationTypeObj[ viewPageID ] = presentation;
                        }
                        sessionStorage.setItem( dcc.productlist.presentation.typeSessionStorageKey, JSON.stringify( presentationTypeObj ) );
                    }
                }
            }
        },
        plain: {
            resizeDebounce: null,
            windowBaseWidth: 0,
            carouselBaseCount: 4,
            carouselCount: 0,
            _instances: [],
            init: function () {
                var jPlainProductsList = jQuery( '.js-dcc-plain-products-list' );
                if ( jPlainProductsList.length > 0 ) {
                    e4.util.require.js( e4.settings.require.handlebars, function () {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-productlist-plain-products' );
                        e4.handlebars.registerHelpers( 'counter compare compare_extended encoder grouped_each' );
                        dcc.productlist.plain.testCarouselCount();
                        dcc.productlist.plain.bindEvents();
                    } );
                }
            },
            bindEvents: function () {
                jQuery( window ).on( 'resize', dcc.productlist.plain.testCarouselCount );
            },
            testCarouselCount: function () {
                clearTimeout( dcc.productlist.plain.resizeDebounce );
                dcc.productlist.plain.resizeDebounce = setTimeout( function () {
                    var windowWidth = jQuery( window ).width();
                    if ( windowWidth < e4.settings.breakpoint.lg && windowWidth >= e4.settings.breakpoint.md ) {
                        dcc.productlist.plain.carouselCount = 2;
                    }
                    else if ( windowWidth < e4.settings.breakpoint.md ) {
                        dcc.productlist.plain.carouselCount = 1;
                    }
                    else {
                        dcc.productlist.plain.carouselCount = 4;
                    }
                    if ( dcc.productlist.plain.carouselCount !== dcc.productlist.plain.carouselBaseCount ) {
                        dcc.productlist.plain.carouselBaseCount = dcc.productlist.plain.carouselCount;
                    }
                    dcc.productlist.plain.build();
                }, 100 );
            },
            build: function () {
                jQuery( '.js-dcc-plain-products-list' ).each( function ( index, domElm ) {
                    if ( dcc.productlist.plain._instances[ index ] === undefined ) {
                        dcc.productlist.plain._instances[ index ] = JSON.parse( jQuery( domElm ).find( '.js-dcc-plain-products-list-data' ).html() );
                    }
                    var data = dcc.productlist.plain._instances[ index ];
                    data.carouselCount = dcc.productlist.plain.carouselCount;
                    jQuery( domElm ).find( '.js-dcc-plain-products-list-products' ).html( e4.handlebars.tmpl.productlistPlainProducts( data ) );
                    dcc.productlist.plain.carousel( domElm );
                } );
            },
            carousel: function ( domElm ) {
                var jCarousel = jQuery( domElm ).find( '.js-dcc-plain-products-list-carousel' );
                if ( jCarousel.length > 0 ) {
                    jCarousel.find( '.carousel-item' ).first().addClass( 'active' );
                    jQuery( '.dcc-product-list-item-add-to-favorites' ).addClass( 'dropup' );
                }
            }
        }
    };
    dcc.product = {
        init: function () {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare compare_extended' );
                dcc.product.imageCarousel.init();
                dcc.product.relatedProducts.init();
            } );
            dcc.product.bindEvents();
            dcc.product.leasing.init();
            dcc.product.autopilot.init();
        },
        bindEvents: function () {
            jQuery( document ).on( 'productadded.e4.cart', function () {
                var jAccessoryTab = jQuery( '#dcc-productpage-tab-accessories' ),
                    intScrollTarget = e4.scrollToAnchor.getTarget( '#' + jAccessoryTab.attr( 'id' ) );
                if ( jAccessoryTab.length === 1 ) {
                    jAccessoryTab.tab( 'show' );
                    jQuery( 'html,body' ).animate( {
                        scrollTop: intScrollTarget
                    }, Math.floor( Math.abs( jQuery( window ).scrollTop() - intScrollTarget ) * e4.settings.scrollToAnchor.speed ), e4.settings.scrollToAnchor.easing, function () {
                        e4.header.hide();
                    } );
                }
            } );
        },
        imageCarousel: {
            isModalOpen: false,
            init: function () {
                var jImageCarousel = jQuery( '.js-e-product-image-container' );
                if ( jImageCarousel.length === 1 ) {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-carousel-images #js-e-handlebars-tmpl-carousel-thumbs #js-e-handlebars-tmpl-carousel-modal-images #js-e-handlebars-tmpl-carousel-modal-thumbs' );
                    dcc.product.imageCarousel.build();
                    //dcc.product.imageCarousel.bindEvents();
                }
            },
            bindEvents: function () {
                jQuery( '#js-e-product-image-modal' ).on( 'shown.bs.modal', function () {
                    dcc.product.imageCarousel.isModalOpen = true;
                } ).on( 'hidden.bs.modal', function () {
                    dcc.product.imageCarousel.isModalOpen = false;
                } );
                jQuery( document ).on( 'keyup', function ( event ) {
                    if ( dcc.product.imageCarousel.isModalOpen === true ) {
                        if ( event.which === 27 ) {
                            jQuery( '#js-e-product-image-modal' ).modal( 'hide' );
                        }
                    }
                } );
            },
            build: function () {
                var carouselImages = window.carouselDataImages,
                    jCarouselImages = jQuery( '.js-dcc-image-carousel-images-container' ),
                    jCarouselThumbs = jQuery( '.js-dcc-image-carousel-thumbs-container' );
                jCarouselImages.html( e4.handlebars.tmpl.carouselImages( carouselImages ) );
                jCarouselThumbs.html( e4.handlebars.tmpl.carouselThumbs( carouselImages ) );
                dcc.product.imageCarousel.images.preload( 0, [
                    jCarouselThumbs,
                    jCarouselImages
                ], false );
                //dcc.product.imageCarousel.images.load();
            },
            images: {
                imageArr: [],
                preload: function ( index, arrImages, isDone ) {
                    if ( isDone === false ) {
                        if ( arrImages !== null ) {
                            dcc.product.imageCarousel.images.imageArr = arrImages;
                        }
                        var currentImageObj = dcc.product.imageCarousel.images.imageArr[ index ],
                            srcLength = jQuery( currentImageObj ).find( '.js-preload-src-image' ).length,
                            imageType = srcLength > 0 ? 'src' : 'bg';
                        dcc.product.imageCarousel.images.loadSrc( index, currentImageObj, imageType );
                    }
                    else {
                        var carouselImages = window.carouselDataImages,
                            jCarouselModalImages = jQuery( '.js-dcc-image-carousel-modal-images-container' ),
                            jCarouselModalThumbs = jQuery( '.js-dcc-image-carousel-modal-thumbs-container' );
                        jCarouselModalImages.html( e4.handlebars.tmpl.carouselModalImages( carouselImages ) );
                        jCarouselModalThumbs.html( e4.handlebars.tmpl.carouselModalThumbs( carouselImages ) );
                    }
                },
                loadSrc: function ( imageObjIndex, imageObj, imageType ) {
                    var imageClassname = imageType === 'src' ? '.js-preload-src-image' : '.js-preload-background-image';
                    jQuery( imageObj ).find( imageClassname ).each( function () {
                        var strImagePath = jQuery( this ).data( 'src' ),
                            domImageElement = this,
                            imageToLoad = new Image();
                        imageToLoad.src = strImagePath;
                        jQuery( imageToLoad ).on( 'load', function () {
                            if ( imageType === 'src' ) {
                                jQuery( domImageElement ).attr( 'src', imageToLoad.src );
                            }
                            else if ( imageType === 'bg' ) {
                                jQuery( domImageElement ).css( 'background-image', 'url(' + imageToLoad.src + ')' );
                            }
                        } ).on( 'error', function () {
                            if ( imageType === 'src' ) {
                                jQuery( domImageElement ).attr( 'src', '/Files/Templates/Designs/dcc/_assets/img/dcc-noimage.svg' );
                            }
                            else if ( imageType === 'bg' ) {
                                jQuery( domImageElement ).css( 'background-image', 'url(/Files/Templates/Designs/dcc/_assets/img/dcc-noimage.svg)' );
                            }
                        } );
                    } );
                    var nextImageGroupIndex = dcc.product.imageCarousel.images.imageArr[ imageObjIndex + 1 ] !== undefined ? ( imageObjIndex + 1 ) : null,
                        isDone = nextImageGroupIndex === null ? true : false;
                    dcc.product.imageCarousel.images.preload( nextImageGroupIndex, null, isDone );
                }
            }
        },
        _relatedProducts: {
            init: function () {
                var jRelatedProductsCarousel = jQuery( '.js-dcc-related-products-carousel' ),
                    jRelatedProductsList = jQuery( '.js-dcc-plain-products-list' );
                if ( jRelatedProductsCarousel.length === 1 ) {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-related-products-carousel-inner #js-e-handlebars-tmpl-related-products-modal-content' );
                    dcc.product._relatedProducts.bindEvents();
                    dcc.product._relatedProducts.load( jRelatedProductsCarousel.data( 'productId' ) );
                }
            },
            bindEvents: function () {
                jQuery( '.js-dcc-related-products-modal' ).on( 'show.bs.modal', function ( event ) {
                    dcc.product._relatedProducts.updateModalContent( jQuery( event.relatedTarget ).data( 'groupId' ) );
                } ).on( 'shown.bs.modal', function ( event ) {
                    jQuery( event.target ).modal( 'handleUpdate' );
                } );
            },
            load: function ( strProductId ) {
                this.jqXHR = jQuery.ajax( {
                    url: '/system/data/related-products',
                    data: {
                        ProductID: strProductId
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: true
                } );
                this.jqXHR.done( function ( json ) {
                    var objCarouselSlideData = dcc.product._relatedProducts.buildCarouselSlideData( json );
                    dcc.product._relatedProducts.buildCarousel( objCarouselSlideData );
                    dcc.product._relatedProducts.saveData( json );
                } );
            },
            buildCarousel: function ( objCarouselSlideData ) {
                var jCarouselInner = jQuery( '.js-dcc-related-products-carousel-inner' );
                jCarouselInner.html( e4.handlebars.tmpl.relatedProductsCarouselInner( objCarouselSlideData ) );
                jCarouselInner.find( '.carousel-item' ).first().addClass( 'active' );
            },
            buildCarouselSlideData: function ( json ) {
                var arrCarouselSlides = [];
                for ( var i = 0; i < json.relatedGroups.length; i++ ) {
                    if ( i % 6 === 0 ) {
                        arrCarouselSlides.push( { relatedGroups: [] } );
                    }
                    arrCarouselSlides[ arrCarouselSlides.length - 1 ].relatedGroups.push( json.relatedGroups[ i ] );
                }
                // console.log( arrCarouselSlides );
                return { slides: arrCarouselSlides };
            },
            saveData: function ( json ) {
                dcc.product._relatedProducts.json = json;
            },
            updateModalContent: function ( strGroupId ) {
                var objRelatedProducts = {};
                jQuery.each( dcc.product._relatedProducts.json.relatedGroups, function ( intIndex, objElement ) {
                    if ( objElement.id === strGroupId ) {
                        objRelatedProducts = objElement;
                        return false;
                    }
                } );
                jQuery( '.js-dcc-related-products-modal-content' ).html( e4.handlebars.tmpl.relatedProductsModalContent( objRelatedProducts ) );
            }
        },
        relatedProducts: {
            init: function () {
                var jRelatedProductsList = jQuery( '.js-dcc-section-related-products' );
                if ( jRelatedProductsList.length === 1 ) {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-configurator-cart-related-products #js-e-handlebars-tmpl-related-products-carousel-inner #js-e-handlebars-tmpl-related-products-modal-content' );
                    e4.handlebars.registerPartials( '#js-e-handlebars-partial-configurator-cart-related-products-details #js-e-handlebars-partial-configurator-cart-related-product' );
                    dcc.product.relatedProducts.bindEvents();
                    e4.handlebars.registerHelpers( 'compare counter compareLength' );
                    dcc.product.relatedProducts.load( jQuery( '.js-dcc-main-product' ).data( 'productId' ), true );
                }
            },
            bindEvents: function () {
                jQuery( '.js-dcc-related-products-modal' ).on( 'show.bs.modal', function ( event ) {
                    dcc.product.relatedProducts.updateModalContent( jQuery( event.relatedTarget ).data( 'groupId' ) );
                } ).on( 'shown.bs.modal', function ( event ) {
                    jQuery( event.target ).modal( 'handleUpdate' );
                } );
                jQuery( '.js-dcc-configurator-cart-related-products-container' ).on( 'click', '.js-dcc-related-list-custom-toggle', function ( event ) {
                    var target = jQuery( event.target ).data( 'target' );
                    if ( jQuery( target ).find( '.js-inner-collapse' ).is( '.show' ) === false ) {
                        event.stopPropagation();
                        jQuery( target ).find( '.js-inner-collapse' ).collapse( 'show' );
                    }
                } ).on( 'click', '.js-dcc-related-list-custom-inner-toggle', function ( event ) {
                    //var target = jQuery( event.target ).data( 'target' );
                    var targets = jQuery( event.target ).closest( '.collapse' ).find( '.js-inner-collapse' );
                    if ( jQuery( this ).attr( 'aria-expanded' ) === 'true' ) {
                        event.stopPropagation();
                        targets.collapse( 'hide' );
                    }
                    else {
                        event.stopPropagation();
                        targets.collapse( 'show' );
                    }
                } );
                jQuery( document ).on( 'shown.bs.collapse', '.p-section-collapse-content', function ( event ) {
                    var target = event.target,
                        targetAddition = 20;
                    if ( jQuery( target ).is( '.js-inner-collapse' ) === true ) {
                        target = jQuery( event.target ).closest( '.e-products' ).find( '.js-e-products-item' ).first();
                        targetAddition = 60;
                    }
                    var intScrollTarget = e4.scrollToAnchor.getTarget( target );
                    if ( jQuery( target ).is( '.dcc-productlist-presentation-list' ) === false ) {
                        jQuery( 'html,body' ).scrollTop( intScrollTarget - targetAddition );
                    }
                } );
            },
            load: function ( strProductId, doStdCalc ) {
                this.jqXHR = jQuery.ajax( {
                    url: '/system/data/related-products',
                    data: {
                        ProductID: strProductId,
                        DoStdCalc: doStdCalc
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: true
                } );
                this.jqXHR.done( function ( json ) {
                    dcc.product.relatedProducts.handleData( json );
                    dcc.product.relatedProducts.saveData( json );
                } );
            },
            handleData: function ( json ) {
                json.collapseCount = 1;
                json.relatedGroups.forEach( function ( group ) {
                    group.products = dcc.configurator.utils.sortByStock( group.products );
                } );
                if ( json.relatedGroups.length ) {
                    dcc.product.relatedProducts.buildStacks( json );
                }
                else {
                    jQuery( dcc.configurator.selectors.cartRelatedContainer ).html( '' );
                    jQuery( '#dcc-productpage-tab-accessories' ).hide();
                    if ( jQuery( '.js-dcc-configurator-section' ).length === 0 && jQuery( '#dcc-productpage-tab-content-specs' ).length > 0 ) {
                        jQuery( '#dcc-productpage-tab-specs' ).tab( 'show' );
                    }
                }
            },
            buildStacks: function ( json ) {
                jQuery( dcc.configurator.selectors.cartRelatedContainer ).html( e4.handlebars.tmpl.configuratorCartRelatedProducts( json ) );
     
            },
            buildCarousel: function ( objCarouselSlideData ) {
                var jCarouselInner = jQuery( '.js-dcc-related-products-carousel-inner' );
                jCarouselInner.html( e4.handlebars.tmpl.relatedProductsCarouselInner( objCarouselSlideData ) );
                jCarouselInner.find( '.carousel-item' ).first().addClass( 'active' );
            },
            buildCarouselSlideData: function ( json ) {
                var arrCarouselSlides = [];
                for ( var i = 0; i < json.relatedGroups.length; i++ ) {
                    if ( i % 6 === 0 ) {
                        arrCarouselSlides.push( { relatedGroups: [] } );
                    }
                    arrCarouselSlides[ arrCarouselSlides.length - 1 ].relatedGroups.push( json.relatedGroups[ i ] );
                }
                // console.log( arrCarouselSlides );
                return { slides: arrCarouselSlides };
            },
            saveData: function ( json ) {
                dcc.product.relatedProducts.json = json;
            },
            updateModalContent: function ( strGroupId ) {
                var objRelatedProducts = {};
                jQuery.each( dcc.product.relatedProducts.json.relatedGroups, function ( intIndex, objElement ) {
                    if ( objElement.id === strGroupId ) {
                        objRelatedProducts = objElement;
                        return false;
                    }
                } );
                jQuery( '.js-dcc-related-products-modal-content' ).html( e4.handlebars.tmpl.relatedProductsModalContent( objRelatedProducts ) );
            }
        },
        autopilot: {
            init: function(){
                dcc.product.autopilot.bindEvents();
            },
            bindEvents: function(){
                jQuery('.js-dcc-autopilot-checkbox').on('change', function(event){
                    dcc.product.autopilot.setValues(event.target.checked, event.isTrigger);
                });
                jQuery('.js-dcc-autopilot-email-input').on('input', function(){
                    dcc.product.autopilot.setValues(true);
                });
            },
            setValues: function(isChecked, isTrigger){
                var jConfigCheckbox = jQuery('.js-dcc-configurator-overview-autopilot-checkbox');
                jQuery('.js-dcc-autopilot-checked-orderline-input').val(isChecked);
                jQuery('.js-dcc-autopilot-email-orderline-input').val(isChecked ? jQuery('.js-dcc-autopilot-email-input').val() : '');
                if( jConfigCheckbox.length > 0 && isTrigger === undefined){
                    dcc.configurator.overview.autopilot.model.open = isChecked;
                    jConfigCheckbox.prop('checked', isChecked).trigger('change');
                } else if( isTrigger !== undefined){
                    jQuery('#dcc-autopilot-collapse').collapse(isChecked ? 'show' : 'hide' );
                }
            }
        },
        leasing: {
            init: function () {
                dcc.product.leasing.bindEvents();
            },
            bindEvents: function () {
                jQuery( '.js-dcc-product-leasing-interest-rate' ).on( 'change', function ( event ) {
                    dcc.product.leasing.togglePrice( event.target );
                } ).triggerHandler( 'change' );
                jQuery( '.js-leasing-offer-checkbox' ).on( 'change', function ( event ) {
                    dcc.product.leasing.toggleOffer( event.target );
                } ).triggerHandler( 'change' );
                jQuery( '.js-dcc-product-leasing-toggle' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    dcc.product.leasing.collapse( event.target );
                } );
            },
            collapse: function ( domElm ) {
                jQuery( '.js-dcc-product-leasing-toggle-target' ).collapse( 'toggle' );
            },
            toggleOffer: function ( domElm ) {
                var jCheckBox = jQuery( '.js-leasing-offer-checkbox' ),
                    jLeasingRate = jQuery( '.js-leasing-offer-input-rate' ),
                    jLeasingPrice = jQuery( '.js-leasing-offer-input-price' ),
                    jLeasingChecked = jQuery( '.js-leasing-offer-input-checked' );
                if ( jCheckBox.is( ':checked' ) === true ) {
                    var avanceiProcent = jQuery( '.js-dcc-product-leasing-interest-rate option:selected' ).text(),
                        leasingPrice = jQuery( '.js-dcc-product-leasing-price' ).text();
                    jLeasingRate.val( avanceiProcent );
                    jLeasingPrice.val( leasingPrice );
                }
                else {
                    jLeasingRate.val( '' );
                    jLeasingPrice.val( '' );
                }
                jLeasingChecked.val( jCheckBox.is( ':checked' ) );
            },
            togglePrice: function ( domElm ) {
                jQuery( '.js-dcc-product-leasing-price' ).html( jQuery( domElm ).val() );
                dcc.product.leasing.toggleOffer( domElm );
            }
        }
    };
    dcc.cart = {
        init: function () {
            jQuery( '.js-e-cart' ).on( 'loaded.e4.cart', dcc.cart.updateOrderlinesQuantity );
        },
        updateOrderlinesQuantity: function () {
            e4.cart.ajax( {
                data: jQuery( '.js-e-cart-form' ).serialize()
            } );
        }
    };
    dcc.sidebarContact = function () {
        var timeOut;
        jQuery( '.js-dcc-custom-sticky-wrapper' ).on( 'click', function () {
            clearTimeout( timeOut );
            jQuery( this ).toggleClass( 'active' );
        } ).on( 'mouseenter', function () {
            clearTimeout( timeOut );
        } ).on( 'mouseleave', function () {
            var selectStickyWrapper = this;
            timeOut = setTimeout( function () {
                jQuery( selectStickyWrapper ).removeClass( 'active' );
            }, 3000 );
        } );
    };
}() );
